import React from 'react';
import UserIdentification from './UserIdentification';
import MembersOnlyEvent from './MembersOnlyEvent';
import RegistrationForm from '../RegistrationForm';

const buildAvailabilityTypes = props => {
  const { event } = props;

  const { restrictedMessage = 'This event is restricted.' } = event || {};
  return {
    eventFull: (
      <p>
        Thank you for your interest in this NFIB event. Currently, no seats are
        available. If you have questions, please contact NFIB by calling the
        number provided in the event details or 1-800-NFIB-NOW.
      </p>
    ),

    pricesExpired: (
      <p>
        Thank you for your interest in this NFIB event. Currently, no pricing
        options are available. If you have questions, please contact NFIB by
        calling the number provided in the event details or 1-800-NFIB-NOW.
      </p>
    ),
    alreadyRegistered: (
      <p>
        You have previously registered for this event. If you need to change
        your registration, please call 1-800-NFIB-NOW or contact the event
        manager at the number provided in the event details.
      </p>
    ),
    available: <RegistrationForm {...props} />,
    unknownUser: <UserIdentification event={event} />,
    memberOnly: <MembersOnlyEvent {...props} />,
    restricted: <p>{restrictedMessage}</p>,
  };
};

export const EventAvailability = props => {
  const { event, currentUser = {}, currentCustomer, isRegistered } = props;
  const {
    isFree,
    isRestricted,
    pricing = [],
    numberOfSeatsAvailable,
    isMembersOnly,
  } =
    event || {};
  const availabilityTypes = buildAvailabilityTypes(props);
  const availablePrices = !isFree
    ? pricing.filter(price => price.isCurrentlyAvailable)
    : [];

  if (isRestricted) {
    return availabilityTypes.restricted;
  }

  if (!currentUser.id && !(currentUser.settings || {}).email) {
    return availabilityTypes.unknownUser;
  }

  if (isRegistered) {
    return availabilityTypes.alreadyRegistered;
  }

  if (!isFree && !availablePrices.length) {
    return availabilityTypes.pricesExpired;
  }

  // if no seats left or if available prices will put event over capacity
  if (
    numberOfSeatsAvailable === 0 ||
    (!isFree &&
      availablePrices.every(
        price => price.isTable && price.numberOfSeats > numberOfSeatsAvailable
      ))
  ) {
    return availabilityTypes.eventFull;
  }

  if (
    isMembersOnly &&
    (!currentCustomer ||
      !currentCustomer.organization ||
      !currentCustomer.organization.isMember)
  ) {
    return availabilityTypes.memberOnly;
  }
  return availabilityTypes.available;
};

export default EventAvailability;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/Availability/index.js